<template>
  <div>
    <table v-if="report.periods.length" class="table is-fullwidth">
      <tr>
        <th class="is-size-8">Metric</th>
        <th v-for="period in billingPeriods" :key="period.id" class="is-size-8 has-text-right">{{ period.short_label }}</th>
      </tr>
      <tr v-for="(row, index) in rows" :key="index">
        <td class="is-size-8">{{ row.label }}</td>
        <td v-for="(metric, index) in report.periods" :key="index" class="is-size-8 has-text-right">
          <p v-if="metric[row.key]"><Currency :value="metric[row.key]" /></p>
          <p v-else><Currency :value="0" /></p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      rows: [{
        label: 'Pending',
        key: 'amount_pending'
      }, {
        label: 'Delivered',
        key: 'amount_pending'
      }, {
        label: 'Scheduled',
        key: 'amount_scheduled'
      }, {
        label: 'Billed',
        key: 'amount_billed'
      }]
    }
  },
  props: {
    billingPeriods: {
      type: Array,
      required: true
    },
    report: {
      type: Object,
      required: true
    }
  }
}
</script>
